import React, { useEffect, useState } from "react";
import { getFreeItemsService,updateFreeItemStatus } from "../../../services/apiService";

const FreeItemsList = () => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchFreeItems();
  }, []);

  const fetchFreeItems = async () => {
    try {
      const res = await getFreeItemsService();
      console.log("API Response:", res.data); // 👈 DEBUG
      setItems(res.data || []);
    } catch (error) {
      console.error("Error fetching free items", error);
    }
  };

const handleStatusToggle = async (item) => {
  try {
    const newStatus = item.active === 1 ? 0 : 1;
    await updateFreeItemStatus(item.id, newStatus); // sends correct payload
    fetchFreeItems(); // refresh table
  } catch (error) {
    alert("Failed to update status");
  }
};


  /* 🔍 SEARCH LOGIC */
  const filteredItems = items.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.productid.toString().includes(text) ||
      item.feeproductid.toString().includes(text) ||
      item.qty.toString().includes(text) ||
      item.productqty.toString().includes(text)
    );
  });

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN");

  return (
    <div className="free-list-wrapper">
      {/* Header */}
      <div className="list-header">
        <h3>Free Items List</h3>
        <input
          type="text"
          placeholder="Search by Product ID / Qty"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <table className="free-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Main Product</th>
            <th>Free Product</th>
            <th>Main Qty</th>
            <th>Free Qty</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {filteredItems.length === 0 ? (
            <tr>
              <td colSpan="8" className="no-data">
                No data found
              </td>
            </tr>
          ) : (
            filteredItems.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.productid}</td>
                <td>{item.feeproductid}</td>
                <td>{item.productqty}</td>
                <td>{item.qty}</td>
                <td>{formatDate(item.fromdate)}</td>
                <td>{formatDate(item.todate)}</td>
                <td>
       <span
  className={`status ${item.active === 1 ? "active" : "inactive"}`}
  onClick={() => handleStatusToggle(item)} // ✅ pass item explicitly
  style={{ cursor: "pointer" }}
></span>

                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Styles */}
      <style>{`
        .free-list-wrapper {
          background: #fff;
          padding: 20px;
          border-radius: 8px;
        }

        .list-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
        }

        .list-header h3 {
          color: #15803d;
          font-weight: 600;
        }

        .list-header input {
          padding: 6px 10px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 13px;
        }

        .free-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }

        .free-table th,
        .free-table td {
          padding: 10px;
          text-align: center;
          border-bottom: 1px solid #e5e7eb;
               color : #464849;
        }

        .free-table thead {
          background: #f3f4f6;
        }

        .free-table tr:nth-child(even) {
          background: #fafafa;
        }

        .status {
          width: 34px;
          height: 18px;
          border-radius: 20px;
          display: inline-block;
          position: relative;
        }

        .status::after {
          content: "";
          width: 14px;
          height: 14px;
          background: #fff;
          border-radius: 50%;
          position: absolute;
          top: 2px;
          left: 2px;
        }

        .status.active {
          background: #16a34a;
        }

        .status.active::after {
          left: 18px;
        }

        .status.inactive {
          background: #ef4444;
        }

        .no-data {
          padding: 20px;
          color: #6b7280;
        }
      `}</style>
    </div>
  );
};

export default FreeItemsList;
